/*
 * Заголовок и описание публичного сайта — ОДНО место на две стороны.
 *
 * Их подставляет и плагин сборки в `dist/index.html` (его читает Google до
 * выполнения скриптов), и главная страница на клиенте после перехода с
 * юридической страницы. Разъехавшись, эти две подписи дали бы ровно тот
 * дефект, ради которого клиентская подстановка и добавлена: в выдаче одно,
 * во вкладке другое. Модуль намеренно без импортов и без `import.meta` —
 * его читает и Node на этапе сборки, и браузер.
 */

export const MARKETING_ORIGIN = 'https://onboardix.com'
export const ERP_ORIGIN = 'https://erp.onboardix.com'

export const MARKETING_TITLE = 'Onboardix — one system for hiring, payroll and management accounting'
export const MARKETING_DESCRIPTION = 'Onboardix brings hiring, onboarding, learning, employee management, partners, finance and business processes together in one system for small and mid-sized international companies.'
